// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__3Ahl8","App":"Toolbar_App__3F7zj","User":"Toolbar_User__bEzpz","Inbox":"Toolbar_Inbox__2Xv_F","Toolbar":"Toolbar_Toolbar__2Lna_"};